import { gql } from '@apollo/client';

export const UPDATE_COLUMN_CONFIGURATIONS = gql`
  mutation UPDATE_COLUMN_CONFIGURATIONS($userPreferences: UserPreferencesModelInput) {
    patchUserPreferences(userPreferences: $userPreferences) {
      dataTableColumnConfigurations {
        columnOrder
        columnSizing
        hiddenColumns
        key
      }
    }
  }
`;
